function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.667 9.333A1.333 1.333 0 014 8h24a1.333 1.333 0 010 2.667H4a1.333 1.333 0 01-1.333-1.334zm0 6.667A1.333 1.333 0 014 14.667h18.667a1.333 1.333 0 110 2.666H4A1.333 1.333 0 012.667 16zM4 21.333A1.333 1.333 0 004 24h13.333a1.333 1.333 0 000-2.667H4z",
    fill: props.color || 'black'
  }));
}
export default SvgSort;